export default __webpack_public_path__ + "static/media/igsnrr.98e9b7f1.png";